import React,{ useState, useEffect} from 'react';
import ScrollToTopBtn from './components/Button/ScrollToTopBtn.js';
import styled from 'styled-components';
// import Home from './Jasper/landing-page-demo.js';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import UncontrolledExample from './components/Carousel/carousel.js'; 



const OutcomeOverview = styled.div`
	width: 100%;
	height: auto;
	min-height: 100vh;
	background-color: #000;
	color: var(--color-white);
	// padding: 0 5rem;
	:nth-child(2n+1) {
		background-color: #222;
	}
	:nth-child(2n+1) h3,
	:nth-child(2n+1) .description h1,
	:nth-child(2n+1) .description p {
		color: #fff;
	}
	:nth-child(2n+1) .description .tag {
		background-color: #fff;
		color: var(--color-text);
    }
    .description {
    	display: flex;
    	flex-direction: column;
    	justify-content: center;
    	padding: 1rem 2rem;
    	padding-right: 0;
    	
    }
    .description.onleft {
    	padding-right: 2rem;
    	padding-left: 0;
    }
    .description h1 {
    	font-size: 32px;
    	font-weight: 300;
    	color: var(--color-text);
    }
    .description p .emoji {
    	font-size: 160%;
    	vertical-align:middle;
    }
    .description p {
    	margin-top: 0;
    	font-size: 100%;
    }
    .description strong {
    	color: #2B90FF;
    	font-weight: bold;
    }
    .description .tag {
    	font-size: 14px;
	    letter-spacing: .5px;
	    margin: 10px 0;
    }
    .image {

		display: flex;
	    align-items: center;
	    justify-content: center;
	    position: relative;
	    box-sizing: border-box;
	}
	.image::before {
	    content: '';
	    display: block;
	    padding-top: 60%;
	}
	.image img {
    	position: absolute;
		height: 100%;
	}
	.image video {
    	position: absolute;
		height: 100%;
	}
	.image img.widthfixed {
		width: 100%;
		height: auto;
		border: 8px solid #111;
		border-radius: 4px;
	}
	.image video.widthfixed {
		width: 100%;
		height: auto;
		border: 8px solid #111;
		border-radius: 4px;
	}
	h4 {
		margin: 0;
	}
`;
const DesignGoal = styled.div`
	<!-- display: flex; -->
	flex-direction: column;
	align-items: start;
	padding: 0 10px 0 0;
	height: 100%;
	>* {
		margin: 0 auto;
	}
	>img {
		display: inline-block;
		position: relative;
		width: 100%;
		height: auto;
	}
	>img:before {
		position: absolute:
		display: block;
		width: 20px;
		height: 20px;
		border-radius: 30px;
		
	}
	>div:last-child {
    padding-right: 0;
    margin-right: 0;
    background-color: red;
  }
	>h1 {
		width: 100%;
		margin: 0;
		color: #0079FF;
		font-size: 4.5em;
		margin-bottom: 10px;
		<!-- text-align: center; -->
	}
	>h3 {
		margin: 20px 0;
		font-weight: 600;
	}
	>p {
		padding-right: 10px;
		margin-bottom: 40px;
	}
`
function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { return images[item.replace('./', '')] = r(item); });
  return images;
}

const images = importAll(require.context('./assets/img/fanduel/', false, /\.(png|jpe?g|svg|gif)$/));

const controls = [
		{ 
	    	src: images['token-1.png'],
	    	class: ''
		},
		{ 
	    	src: images['token-2.png'],
	    	class: ''
		}
];
const Wyndham = (props) => {
	useEffect(()=>{
		const faders = document.querySelectorAll(".section-box");

		const appearOptions = {
			threshold: 0,
			rootMargin: "0px 0px -150px 0px"
		};

		const appearOnScroll = new IntersectionObserver(function(
			entries,
			appearOnScroll
		) {
			entries.forEach(entry => {

				if (!entry.isIntersecting) {
					return;
				} else {
					entry.target.classList.add("appear");
					entry.target.classList.add("animate__animated");
					entry.target.classList.add("animate__fadeInUp");
					appearOnScroll.unobserve(entry.target);
				}
			});
		},
		appearOptions);

		faders.forEach(fader => {
			appearOnScroll.observe(fader);
		});



	},[])
	

		return (
		<div className="flex fanduel" style={{position: "relative", top: "80px"}}>
			<portfolio-intro className="flex">
				
				<div className="hero-img-box">
					<img src={images['cover3.png']} style={{backgroundColor: '#222', height:"auto", width:"100%"}} alt="" />
				</div>
				
			</portfolio-intro>

			<div className="portfolio-content flex-width-70">
				<h1>Component Upgrader Plugin</h1>
				<div className="section-box brief">
					<div className="grid grid-gap-xs">
						<div className="col-xl-4 col-md-4 col-xs-6 col-6">
							<h4>My Role</h4>
							<ul>
								<li>Product Designer</li>
								<li>UX Engineer</li>
							</ul>
						</div>
						<div className="col-xl-4 col-md-4 col-xs-6 col-6">
							<h4>Duration</h4>
							<ul>
								<li>Sep - Dec 2024</li>
							</ul>
							
						</div>
						
						
						<div className="col-xl-4 col-md-4 col-xs-6 col-6">
							<h4>Deliverables</h4>
							<ul>
								<li>Custom-Built Plugin</li>
								<li>Figma Playground File</li>
								<li>Training Session</li>
							</ul>
							
						</div>
					</div>	
				</div>
				
				<div className="section-box">
					<h3 className="section-title">The background</h3>
					{/*Plugin Development for Automated Component Upgrade */}	
					<p>To improve our design system, we have been enhancing, rebuilding, and introducing new components with better functionality and full support for themes and modes. As part of streamlining our libraries, we marked outdated components with deprecated colored overlays and removed old libraries to create a cleaner, more maintainable Figma workspace. Since many components were outdated, we've encouraged designers to replace them with updated versions for greater consistency and flexibility across products.</p>

					<p>Then I identified a recurring issue: the manual process of replacing deprecated components with updated ones. This process was time-consuming, error-prone, and required designers to manually adjust variants and overrides for each component. It often led to inconsistencies in design files and slowed down the adoption of the latest components across the organization. Then we end up found many deprecated components left untouched in files. So I developed a Figma plugin that automates upgrading deprecated components with a single click.</p>
					<p>Here is a overview of what the plugin can do:</p>
					
					<img className="widthfixed" style={{"width": "100%", "border": "8px solid rgb(200, 200, 200)",
    "border-radius": "4px"}} src={images['plugin.gif']} alt="" />
    			<p>It instantly upgrades outdated components to new, flexible versions with a single click. The plugin applies the correct variants, preserves overrides, and gives you control over the update scope.</p>
				</div>

			</div>


				{/*	<div className="section-box fullscreen-container flex flex-center">
							<OutcomeOverview className="grid" style={{"min-height": "100vh"}}>
								<div className="col-1">
								</div>
								<div className="description onleft col-xl-3 col-md-3 col-xs-12 col-12">
									<h1> Component Updates with One Click</h1>
									<p>Instantly upgrade outdated components to new, flexible versions with a single click. The plugin applies the correct variants, preserves overrides, and gives you control over the update scope.</p>
								</div>
								<div className="image col-xl-7 col-md-7 col-xs-12 col-12">
									<img className="widthfixed" src={images['plugin.gif']} alt="" />
								</div>
									
							</OutcomeOverview>
				</div>	
			*/}				

<div className="portfolio-content flex-width-70">
				<div className="section-box">
					<h3 className="section-title">The Impact</h3>
					<p>The component upgrader plugin significantly improved efficiency, consistency, and scalability within the design system.</p>
					<div className="grid">
					{
		              [{ 
		                  title: "",
		                  number: "20hrs",
		                  description: "per week saved by cutting component replacement time from 2 minutes to 2 seconds across 10 designers."
		              },
		              { 
		                  title: "",
		                  number: "98%",
		                  description: "fewer component-related inconsistencies by eliminating variant-selection errors and preserving overrides."
		              },
		              { 
		                  title: "",
		                  number: "100+",
		                  description: "design files updated in one seamless rollout of new components."
		              }
		            ].map((item,i) => (
		              <DesignGoal key = {i} className="col-xl-4 col-md-4 col-xs-4 col-12">
											<h3>{item.title}</h3>
											<h1>{item.number}</h1>
											<p>{item.description}</p>
		              </DesignGoal>
		            ))}
		          
					</div>
					<div>
						<p>Since the initial release, I have continued to add new features and release updated versions of the plugin. Most recently, I introduced support for automatically replacing <strong>300+ legacy and vertical-specific icons</strong>, while preserving overrides for size and color. The plugin now supports <strong>18 components</strong> with <strong>360+ variants</strong>.</p>
						<br></br>
					</div>
				</div>
				

				





			


			</div>

	{/*		<div className="section-box fullscreen-container flex flex-center">

				<OutcomeOverview className="grid" style={{"min-height": "100vh"}}>
					<div className="col-1">
					</div>
				
					<div className="image col-xl-7 col-md-7 col-xs-12 col-12">
						<p>Automation is critical for scaling design system adoption in large organizations.
						Identifying and addressing pain points within the workflow can lead to impactful solutions that save time and increase consistency.
						Collaboration with cross-functional teams (developers, QA, and PMs) ensures the plugin aligns with both design and development needs.
						This project highlights my ability to not only identify systemic issues but also deliver innovative tools that drive efficiency and consistency at scale.</p>
					</div>
				</OutcomeOverview>

			</div>

		*/}	
{/*----------------------------------- The Solution -----------------------------------*/}	

			<div className="section-box fullscreen-container flex flex-center">

				<OutcomeOverview className="grid">
					<div className="col-1">

					</div>
					<div className="image col-xl-5 col-md-5 col-xs-12 col-12">
						<img className="widthfixed" src={images['oldreplacement.gif']} alt="" />
					</div>
					<div className="description col-xl-5 col-md-5 col-xs-12 col-12">
						<h1><span className="emoji">😶‍🌫️ </span> Before: Manual Replacement</h1>
						<p>The users have to manually swap outdated instances, which removes overrides. Fixing them takes about <strong>2 minutes</strong> per frame. With 100+ frames in large files—making the process time-consuming.</p>
						<p style={{"margin-bottom": "0"}}> 🔹 <strong>Time-consuming:</strong> Required extensive manual work.</p>
						<p style={{"margin-bottom": "0"}}> 🔹 <strong>Manual Adjustments:</strong> Needed to adjust variants and overrides by hand.</p>
						<p style={{"margin-bottom": "0"}}> 🔹 <strong>Error-prone:</strong> Increased the risk of mistakes. Led to design inconsistencies</p>
						<p style={{"margin-bottom": "0"}}> 🔹 <strong>Slowed down the adoption:</strong> deprecated components left untouched</p>
					</div>
					<div className="col-1">
					</div>
				</OutcomeOverview>

				<OutcomeOverview className="grid">
					
					<div className="col-1">
					</div>
					<div className="image col-xl-5 col-md-5 col-xs-12 col-12">
						<img className="widthfixed" src={images['newreplacement.gif']} alt="" />
					</div>
					<div className="description col-xl-5 col-md-5 col-xs-12 col-12">
						<h1><span className="emoji">🥳 </span>After: Automated Replacement</h1>
						<p>Using the plugin is a game changer—components are replaced in under <strong>2 seconds</strong> per frame, with correct variants applied and overrides preserved.</p>
						{/* <p>🔹 Automatic Replacement: Replaces deprecated components</p>
						<p>🔹 Contextual Variants: Applies appropriate variants</p>
						<p>🔹 Preserves Overrides: Retains customized styles</p>
						<p>🔹 Time Efficiency: Reduces update effort</p> */}	
						<p style={{"margin-bottom": "0"}}> 🔹 <strong>Automatic Replacement:</strong> Replaces deprecated components</p >
						<p style={{"margin-bottom": "0"}}> 🔹 <strong>Contextual Variants:</strong> Applies appropriate variants</p >
						<p style={{"margin-bottom": "0"}}> 🔹 <strong>Preserves Overrides:</strong> Retains customized styles</p >
						<p style={{"margin-bottom": "0"}}> 🔹 <strong>Time Efficiency:</strong> Reduces update effort</p >
					</div>
				</OutcomeOverview>

		

				<OutcomeOverview className="grid" style={{"min-height": "100vh"}}>
					<div className="col-1">
					</div>
					<div className="description col-xl-3 col-md-3 col-xs-12 col-12">
						<h1> Component Updates with One Click</h1>
						<p>Instantly upgrade outdated components to new, flexible versions with a single click. The plugin applies the correct variants, preserves overrides, and gives you control over the update scope.</p>
					</div>
					<div className="image col-xl-7 col-md-7 col-xs-12 col-12">
						<img className="widthfixed" src={images['plugin.gif']} alt="" />
					</div>
						
				</OutcomeOverview>

				<OutcomeOverview className="grid">
					<div className="col-1"></div>
					<div className="description col-xl-3 col-md-3 col-xs-12 col-12">
						<h1>Figma Playground File </h1>
						<p>I created a Figma playground file for exploring the plugin, along with a step-by-step guide to help users upgrade their design files.</p>
					</div>
					<div className="image col-xl-7 col-md-7 col-xs-12 col-12">
						<img className="widthfixed" src={images['playgroundfile.png']} alt=""  style={{"border": "0px"}} />
					</div>
					
				</OutcomeOverview>

				<OutcomeOverview className="grid">
					<div className="col-1"></div>
					<div className="description col-xl-3 col-md-3 col-xs-12 col-12">
						<h1>Training Session: Streamline Upgrades and Boost Adoption</h1>
						<p>I host a session to demonstrate how to upgrade deprecated components and guide teams on applying the newest foundations, components, and variable themes. This boosts design system adoption and improves efficiency, consistency, and scalability.</p>
					</div>
					<div className="image col-xl-7 col-md-7 col-xs-12 col-12">
						<img className="widthfixed" src={images['workshop.png']} alt="" />
					</div>
					

				</OutcomeOverview>

				


				




			</div>





			{/*----------------------------------- The Solution -----------------------------------*/}	
			<div className="portfolio-content flex-width-70">
			
				<div className="section-box">
					<h3 className="section-title">The Technical Details</h3>	
					<p>The plugin automates the replacement process, eliminates variant selection errors, and preserves overrides such as text, color styles, and corner radius. Below is an example using the text field component to show how the plugin compares to manual swapping.</p>
					<div className="grid" >
					{
		              [{ 
		                  title: "🔹 Variant Matching",
		                  img: images['correctupdate.png'],
		                  description: "Our new components now use a boolean property to show or hide elements. The plugin automatically replaces deprecated components with updated ones, and sets the correct boolean state - no manual adjustments needed"
		              },
		              { 
		                  title: "🔹 Preserve Original Design",
		                  img: images['correctvariant.png'],
		                  description: "Applies the appropriate variants and overrides based on the context of the design."
		              },
		              { 
		                  title: "🔹 Preserve the Overrides",
		                  img: images['correctoverrides.png'],
		                  description: "Preserves existing overrides, ensuring no loss of customized styles or data."
		              }
		            ].map((item,i) => (
		              <DesignGoal key = {i} className="col-12">
		              		<h3>{item.title}</h3>
											<p>{item.description}</p>
		                	<img src={item.img} alt="" />
		              </DesignGoal>
		            ))}
					</div>

				</div>

			</div>



			<div className="section-box fullscreen-container flex flex-center">
							<OutcomeOverview className="grid" style={{"min-height": "100vh"}}>
								<div className="col-1">
								</div>
								<div className="description col-xl-4 col-md-4 col-xs-12 col-12">
									<h1> Thanks for reading</h1>
									<p>If you're interested in how I implemented the code behind the plugin, feel free to reach out—I'd be happy to share more.</p>
								</div>
								<div className="image col-xl-6 col-md-6 col-xs-12 col-12">
									<img className="widthfixed" src={images['code.png']} alt="" />
								</div>
									
							</OutcomeOverview>
				</div>	
			

			







			
			



			<ScrollToTopBtn></ScrollToTopBtn>
		</div>
		)
	
}
export default Wyndham;